import { sections as sectionsUtils } from '#packages/util';
import { events } from '#packages/coreBi';

import {
  cleanupEditorData,
  getPagesVisibleInMenu,
  hasPagesWithoutSectionsInRoot,
} from '../utils';
import { MIGRATION_VERSION } from '../version';
import { MigrationFlow } from '../types';
import { saveInBackground } from './saveMigration';

import type { SectionsMigrationScope as Scope } from '../scope';
import type { MigrationOrigin } from '../constants';
import type { CompRef } from 'types/documentServices';

export function skipMigration(scope: Scope) {
  scope.editorCoreAPI.hooks.sectionsMigrationReady.resolve({
    isMigrated: false,
  });

  cleanupEditorData(scope.editorAPI.documentServices);
}

export function resolveMigration(
  scope: Scope,
  {
    flow,
    origin,
    pagesRefs,
  }: {
    flow: MigrationFlow;
    origin: MigrationOrigin;
    pagesRefs?: CompRef[];
  },
) {
  if (
    flow === MigrationFlow.PerPageADI ||
    flow === MigrationFlow.PerPageEditor
  ) {
    updateSectionsEditorDataForPerPageFlow(scope, flow, pagesRefs);
  } else {
    sectionsUtils.updateSiteSectionsEditorData(scope.editorAPI, {
      isSectionsEnabled: true,
      isMigratedFromAdi: flow === MigrationFlow.ADI,
      migrationVersion: MIGRATION_VERSION,
    });
  }

  scope.editorAPI.bi.event(events.sectionsMigration.MIGRATION_SUCCESS, {
    flow,
    origin,
    duration: 0,
    pages_list: '',
    is_document_changed: false,
    is_home_page:
      flow === MigrationFlow.PerPageEditor || flow === MigrationFlow.PerPageADI
        ? pagesRefs?.[0]?.id === scope.editorAPI.homePage.get()
        : null,
    template_id:
      scope.editorAPI.documentServices.generalInfo.getSiteOriginalTemplateId(),
    fully_migrated:
      flow === MigrationFlow.PerPageEditor || flow === MigrationFlow.PerPageADI
        ? !hasPagesWithoutSectionsInRoot(
            scope.editorAPI.documentServices,
            getPagesVisibleInMenu(scope.editorAPI.documentServices),
          )
        : null,
  });

  if (flow !== MigrationFlow.Template) {
    void saveInBackground(scope);
  }

  scope.editorCoreAPI.hooks.sectionsMigrationReady.resolve({
    isMigrated: true,
  });
}

function updateSectionsEditorDataForPerPageFlow(
  scope: Scope,
  flow: MigrationFlow,
  pagesRefs: CompRef[],
) {
  const isHomePage = pagesRefs?.[0]?.id === scope.editorAPI.homePage.get();

  if (isHomePage) {
    sectionsUtils.updateSiteSectionsEditorData(scope.editorAPI, {
      isSectionsEnabled: true,
      isMigratedFromAdi: flow === MigrationFlow.PerPageADI,
      migrationVersion: MIGRATION_VERSION,
    });
  }

  sectionsUtils.updatePageSectionsEditorData(
    scope.editorAPI,
    {
      isSectionsEnabled: true,
      isMigratedFromAdi: flow === MigrationFlow.PerPageADI,
      migrationVersion: MIGRATION_VERSION,
    },
    pagesRefs,
  );
}
